import {AppFrameDeskFeat, IApp, IAppBuilder, IAppCtx, JAppDef} from "/@back@/core/appFrame.js";
import {ItemEdApp} from "/@back@/wsp/apps/itemEdApp.js";
import {OItemXmlEdInit} from "/@back@/wsp/views/item/itemXmlEd.js";
import {SimpleTagArea} from "/@lib@/commons/areas.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {IChainEnv} from "/@lib@/wsp/chain.js";


/**
 * Accès direct à un éditeur d'un item.
 * A appeler au cours du processus d'init du desk (qui doit disposer de AppFrameDeskFeat).
 *
 * @param reg Registre à exploiter correspondant au chain, nécessaire en cas de front multi-universe.
 */
export function initApp(reg: IReg<IChainEnv> = REG.reg) {
	const d = desk as AppFrameDeskFeat;
	d.addAppBuilder(new ItemEdAppBuilder(reg));
}

/** Définition pour une ItemEdApp. */
export interface JItemEdAppDef extends JAppDef {
	itemEd: OItemXmlEdInit
}

/** Construction async de l'App. */
export class ItemEdAppBuilder extends SimpleTagArea<IAppCtx<IChainEnv>, IApp<IChainEnv>> implements IAppBuilder<IChainEnv, IChainEnv> {

	/** Configuration particulière de l'éditeur. */
	edConfig: OItemXmlEdInit;

	constructor(public reg: IReg<IChainEnv>) {
		super('wsp-item-ed-app', reg.env.resolver.resolve(":back:wsp/apps/itemEdApp.js"));
	}

	isAppDefMatch(data: JItemEdAppDef) {return typeof data.itemEd === 'object'}

	newElt(ctx: IAppCtx<IChainEnv>): ItemEdApp {
		if (this.edConfig) Object.assign(ctx, this.edConfig);
		ctx.reg = this.reg;
		return (super.newElt(ctx) as ItemEdApp).initialize(ctx);
	}
}
